import { render } from "./TheScrollTopButton.vue?vue&type=template&id=49a7cd4c&scoped=true"
import script from "./TheScrollTopButton.vue?vue&type=script&lang=js"
export * from "./TheScrollTopButton.vue?vue&type=script&lang=js"

import "./TheScrollTopButton.vue?vue&type=style&index=0&id=49a7cd4c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a7cd4c"]])

export default __exports__